var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    _vm._b({}, "gg-card", _vm.$attrs, false),
    [
      _c("gg-card-text", [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "nowrap",
              gap: "16px"
            }
          },
          [
            _vm.isWithIcon && !_vm.iconWithTitle
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "flex-basis": "30px"
                    }
                  },
                  [
                    _vm._t("icon", [
                      _c(
                        "v-icon",
                        {
                          class: "mt-2 " + _vm.iconClass,
                          style: _vm.iconStyle,
                          attrs: {
                            size: _vm.iconSize,
                            color: _vm.iconColor
                          }
                        },
                        [_vm._v(_vm._s(_vm.icon))]
                      )
                    ])
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              {
                style: "flex-grow: 1; min-width: ".concat(_vm.mainBlockMinWidth)
              },
              [
                _vm._t("default", [
                  _c(
                    "div",
                    {
                      class: _vm.titleClass,
                      style: _vm.titleStyle
                    },
                    [
                      _vm.iconWithTitle
                        ? _vm._t("icon", [
                            _c(
                              "v-icon",
                              {
                                class: "mb-1 " + _vm.iconClass,
                                style: _vm.iconStyle,
                                attrs: {
                                  size: _vm.iconSize,
                                  color: _vm.iconColor
                                }
                              },
                              [_vm._v(_vm._s(_vm.icon))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.title) + " ")
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      class: _vm.textClass,
                      style: _vm.textStyle
                    },
                    [_vm._t("text", [_vm._v(" " + _vm._s(_vm.text) + " ")])],
                    2
                  )
                ])
              ],
              2
            ),
            _vm.isWithAppend ? _c("div", [_vm._t("append")], 2) : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }